import CheckInSettings from './CheckInSetting';
export default CheckInSettings;
